module.exports = __webpack_public_path__ + "static/img/women.d8661580.jpeg";